import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.4 9L3.3 14.55L15.15 9L3.3 3.45L5.4 9ZM15.15 9H5.4",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSendPlane;
